module.exports = __webpack_public_path__ + "static/media/favicon-un.4735b271.ico";